import { render } from "./Footer.vue?vue&type=template&id=68d3d2de&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=68d3d2de&scoped=true&lang=css"

import exportComponent from "/data/webcode/iotopenplattform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d3d2de"]])

export default __exports__